/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import { Button, CircularProgress, IconButton, TableCell, TableRow, TableSortLabel } from '@mui/material';
import { ArrowDownwardRounded, ArrowForwardRounded, CheckRounded, CloseRounded } from '@mui/icons-material';
import styled from 'styled-components';
import appTheme from '../../../../common/theme/appTheme.json';
import StyledProps from '../../../../common/theme/AppThemeInterface';
export const StyledTableSortLabel = styled(TableSortLabel)``;
export const StyledArrowDownwardRounded = styled(ArrowDownwardRounded)`
  font-size: 18px !important;
  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor} !important;
`;
export const StyledTableHeaderCell = styled(TableCell)`
  color: ${({ theme }: StyledProps) => theme.primaryTextColor}cc;
  letter-spacing: 0.5px;
  font-size: 12px;
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  min-width: 5px;
  border-bottom: none;
  text-transform: uppercase;
  padding: 10px 0px;
  background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};
`;
export const StyledTableCell = styled(TableCell)`
  font-size: 14px;
  min-width: 5px;
  color: ${({ theme }: StyledProps) => theme.primaryTextColor};
  font-family: ${({ theme }: StyledProps) => theme.appFontFamily};
  cursor: pointer;
  border-bottom: none;
  letter-spacing: 0.5px;
  padding: 4px 0px;
`;

export const StyledTableRow = styled(TableRow)`
  &:hover {
    background-color: ${({ theme }: StyledProps) => theme.secondaryBackgroundColor};
  }
`;
export const StyledCloseRounded = styled(CloseRounded)`
  color: ${appTheme.primaryTextColor};
`;
export const StyledCheckRounded = styled(CheckRounded)`
  color: ${appTheme.buttonSelectedColor} !important;
`;
export const StyledArrowForwardRounded = styled(ArrowForwardRounded)`
  color: ${appTheme.primaryTextColor};
`;
export const StyledPanelWrapper = styled.div`
  height: 404px;
  min-width: 750px;
  width: 750px;
  max-width: 750px;
  background-color: ${({ theme }: StyledProps) => theme.primaryBackgroundColor};
  .loading__error__message__container {
    position: absolute;
    width: 100%;
    top: 185px;
    height: 0px;
    text-align: center;
    color: ${({ theme }: StyledProps) => theme.primaryTextColor};
    .progress {
      color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
    }
    .try__again__button {
      z-index: 5;
      color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
    }
  }
`;

export const StyledClose = styled(CloseRounded)`
  color: white;
`;

export const StyledIconButton = styled(IconButton)`
  position: absolute;
  right: -0px;
`;
export const StyledTryAgainButton = styled(Button)`
  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
`;
export const StyledOverlayMissionText = styled.span`
  cursor: pointer;
`;

export const ErrorRequestingMissionsMessageContainer = styled.div`
  display: block;
`;
export const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ theme }: StyledProps) => theme.buttonSelectedColor};
`;
